import { LoadingStatusEnum } from '../../../constants/enums';

export const REDUCER_NAME = 'userWhiteList';

export default {
  loading: LoadingStatusEnum.Idle,
  list: [],
};
